import React from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import { CardActions } from "@material-ui/core";
import AuthContext from "../../../AuthContext";
import mtzApis from "../../../services";
import CompanyCategorySelect from "../../company-service/categories/CompanyCategorySelect";
import "./style.css";
const { companyService } = mtzApis;

function CompanyCategoryManager({ onChange, companyId, profileName, header }) {
  let params = new URLSearchParams(window.location.search);
  let filter = { ...Object.fromEntries(params) }
  let [company, setCompany] = React.useState(null);
  let [categories, setCategories] = React.useState(null);

  const me = React.useContext(AuthContext);

  React.useEffect(() => {
    (async () => {
      init();
    })();
  }, [companyId, profileName]);

  const init = async () => {
    let company;
    if (companyId) company = await companyService.getCompanyById(companyId);
    if (profileName) {
      const companies = await companyService.getCompanies(
        new URLSearchParams(`profileName=${profileName}`)
      );
      if (companies) company = companies[0];
    }
    if (!company) return;
    setCompany(company);

    const categories = await companyService.getCategories(
      new URLSearchParams(`categoryIds=${company.categoryIds}`)
    );
    if (categories) setCategories(categories);
  };

  const onChangeHandler = async (categoryIds) => {
    if (!categoryIds || categoryIds.length === 0) return;
    mtzApis.startSpinningIcon();
    const updated = await companyService.updateCompanyById(company.id, { categoryIds });
    mtzApis.stopSpinningIcon();
    if (updated) {
      const categories = await companyService.getCategories(
        new URLSearchParams(`categoryIds=${updated.categoryIds}`)
      );
      if (categories) setCategories(categories);
      setCompany(updated);
      if (onChange) onChange(updated.categoryIds);
    } else {
      setCompany({ ...company });
      if (onChange) onChange(company.categoryIds);
    }
  };

  return (
    <React.Fragment>
      <Card id="mtz-company-categories" className="company-category" elevation={0}>
        <CardHeader subheader={<h5 className="company-category-text">Who are we?</h5>} />
        <CardContent>
          {categories && categories.length > 0 ? (
            categories.map((category) => {
              let code = "",
                type = "SIMPLE";
              if (category.naiscCode) {
                code = category.naiscCode;
                type = "NAICS";
              }
              if (category.sicCode) {
                code = category.sicCode;
                type = "SIC";
              }
              return (
                <div key={category.id} className="m-1 company-category-chip">
                  <span className="company-category-chip-font">
                    {category.name + (type === 'SIMPLE' ? '' : "-" + type + ": " + code)}
                  </span>
                </div>
              );
            })
          ) : (
            <div>No category selected.</div>
          )}
        </CardContent>
        {me && company && me.userId === company.ownerId && (
          <CardActions style={{ width: "100%", justifyContent: "flex-end" }}>
            <button
              className="btn btn-sm btn-link"
              data-toggle='modal' data-target='#comp-cat-modal'
            >
              Edit category <span className="fa fa-edit"></span>
            </button>

            <div id="comp-cat-modal" className="modal">
              <div className="modal-dialog modal-dialog-scrollable modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <div className="d-flex w-100 align-items-center">
                      <h5 className="flex-fill mtz-h5">Company Category Manager:</h5>
                      <button className="btn btn-sm close" data-dismiss='modal'>
                        <span className="fa fa-close"></span>
                      </button>
                    </div>
                  </div>
                  <div className="modal-body">
                    <CompanyCategorySelect
                      title="What's your industry?"
                      categoryIds={company.categoryIds || []}
                      onChange={onChangeHandler}
                    />
                  </div>
                </div>
              </div>
            </div>
          </CardActions>
        )}
      </Card>
    </React.Fragment>
  );
}

export default CompanyCategoryManager;
